import {BillingInfo} from '@eitje/api'
import {PageLayout, Filters, BillingInfosAdvancedTable} from '~/components'
import {BillingInfosPageHeader} from './page_header'

export const BillingInfos = () => {
	const items = BillingInfo.useAll({joins: ['environments', 'organisations']})

	return (
		<PageLayout
			name="billing_infos"
			headers={[<BillingInfosPageHeader key={0} />, <Filters key={1} />]}
			filterProps={{items, filters: ['billingInfo', 'bankAccountName', 'organisation', 'environment', 'priceAgreement']}}
		>
			<BillingInfosAdvancedTable />
		</PageLayout>
	)
}
